import { SubCategoryResult } from "@core/services/api.service";

export class CategoryModel {


    constructor(public model: SubCategoryResult) {    }

    isSelected: boolean = false;
    select(cat: CategoryModel) { 
        let newCat = new CategoryModel(cat.model)
         newCat.isSelected = !cat.isSelected
        return newCat;
    }
}
